import Boundary from "./boundary";

class Group extends Boundary {
    groupName;

    constructor(props) {
        super();
        this.groupName = props.name;
        this.volumes = [];
        this.modelName = undefined;
        this._populateGroupVolumes();
        this._addHandlers();
        this.updateBoundingBox();
    }

    _addHandlers() {
        addHandlerForOperation(this.modelId, [this.modelId], this.updateBoundingBox.bind(this), this.groupName + "boundary",
            HANDLER_TYPE_ENUM.BOUNDARY, HANDLER_TYPE_ENUM.BOUNDARY);
    }

    _populateGroupVolumes() {
        const group = GroupData.getGroupByName(this.groupName);
        if (group) {
            this.volumes = group.getValidVolumeBranchIds();
            this.modelId = getModelIdFromBranchId(this.volumes[0]);
            this.modelName = modelManager.getModelNamebyModelId(this.modelId);
        }
    }

    updateBoundingBox() {
        const groupBoundingBox = getCurrentBoundingBoxOfVolumesInWorld(this.volumes);
        if (groupBoundingBox) {
            this.bBox.copy(groupBoundingBox);
        }
    }
}

export default Group;
